var map = {
	"./App": 56684,
	"./App.vue": 56684,
	"./assets/about/Group.png": 31009,
	"./assets/about/Group2.png": 3143,
	"./assets/about/Group3.png": 34302,
	"./assets/about/food.png": 67038,
	"./assets/about/food2.jpeg": 67239,
	"./assets/about/pay.png": 46230,
	"./assets/about/people.png": 61255,
	"./assets/about/people2.png": 67541,
	"./assets/about/title.png": 17494,
	"./assets/about/title2.png": 3734,
	"./assets/about/title3.png": 57535,
	"./assets/about/title4.png": 29504,
	"./assets/baozang.gif": 18417,
	"./assets/browse/off-icon.png": 34284,
	"./assets/browse/search_icon.png": 18811,
	"./assets/browse/shop_car_empty.png": 51062,
	"./assets/contact/add.png": 87954,
	"./assets/contact/email.png": 25003,
	"./assets/contact/icon1.png": 41931,
	"./assets/contact/icon2.png": 28112,
	"./assets/contact/icon3.png": 34361,
	"./assets/contact/icon4.png": 93209,
	"./assets/contact/icon5.png": 97135,
	"./assets/contact/icon6.png": 92020,
	"./assets/contact/icon7.png": 13149,
	"./assets/contact/icon8.png": 86026,
	"./assets/contact/phone.png": 40543,
	"./assets/contact/wx.png": 98918,
	"./assets/contact/x.png": 72275,
	"./assets/cuisine/Asian/Asian1.png": 13931,
	"./assets/cuisine/Asian/Asian2.png": 112,
	"./assets/cuisine/Asian/Asian3.png": 6361,
	"./assets/cuisine/Burgers/burgers1.png": 73899,
	"./assets/cuisine/Burgers/burgers2.png": 60080,
	"./assets/cuisine/Burgers/burgers3.png": 66329,
	"./assets/cuisine/Chinese/Chinese1.png": 93591,
	"./assets/cuisine/Chinese/Chinese2.png": 4860,
	"./assets/cuisine/Chinese/Chinese3.png": 22373,
	"./assets/cuisine/Indian/img1.png": 51623,
	"./assets/cuisine/Indian/img2.png": 31564,
	"./assets/cuisine/Indian/img3.png": 661,
	"./assets/cuisine/Japanese/Japanese1.png": 5695,
	"./assets/cuisine/Japanese/Japanese2.png": 20420,
	"./assets/cuisine/Japanese/Japanese3.png": 83661,
	"./assets/cuisine/Kebabs/Kebabs1.png": 54773,
	"./assets/cuisine/Kebabs/Kebabs2.png": 34398,
	"./assets/cuisine/Korean/Korean1.png": 60017,
	"./assets/cuisine/Korean/Korean2.png": 83770,
	"./assets/cuisine/Korean/Korean3.png": 89955,
	"./assets/cuisine/Pizza/Pizza1.png": 33855,
	"./assets/cuisine/Pizza/Pizza2.png": 48580,
	"./assets/cuisine/Pizza/Pizza3.png": 11821,
	"./assets/cuisine/Thai/Thai1.png": 18785,
	"./assets/cuisine/Thai/Thai2.png": 69802,
	"./assets/cuisine/Thai/Thai3.png": 20563,
	"./assets/cuisine/cuisine_bg_1.png": 93625,
	"./assets/cuisine/cuisine_bg_2.png": 79618,
	"./assets/cuisine/cuisine_bg_3.png": 43275,
	"./assets/cuisine/cuisine_bg_4.png": 51284,
	"./assets/cuisine/cuisine_desc_demo.png": 90473,
	"./assets/flag/Flag_of_Portugal.png": 99584,
	"./assets/flag/Romania.png": 93738,
	"./assets/flag/Sweden.png": 31747,
	"./assets/flag/a-Austriaaodiliguoqi.png": 21587,
	"./assets/flag/a-Belgiumbilishiguoqi.png": 22655,
	"./assets/flag/a-Danmarkdanmaiguoqi.png": 19818,
	"./assets/flag/a-Finlandfenlanguoqi.png": 60236,
	"./assets/flag/a-Greekxilaguoqi.png": 67488,
	"./assets/flag/a-Holandhelanguoqi.png": 24778,
	"./assets/flag/a-Irelandaierlanguoqi.png": 31593,
	"./assets/flag/a-Italyyidaliguoqi.png": 76361,
	"./assets/flag/a-Norwaynuoweiguoqi.png": 47779,
	"./assets/flag/a-Swedenruidianguoqi.png": 52400,
	"./assets/flag/america.png": 2715,
	"./assets/flag/aodaliya.png": 217,
	"./assets/flag/bingdao.png": 29529,
	"./assets/flag/canada.png": 55841,
	"./assets/flag/china.png": 73726,
	"./assets/flag/deguoguoqi.png": 22662,
	"./assets/flag/france.png": 93478,
	"./assets/flag/hungary.png": 73721,
	"./assets/flag/maerta.png": 75909,
	"./assets/flag/poland.png": 64312,
	"./assets/flag/ruishi.png": 90845,
	"./assets/flag/saipulusi.png": 26906,
	"./assets/flag/siluofake.png": 37008,
	"./assets/flag/siluowenniya.png": 1160,
	"./assets/flag/uk.png": 63459,
	"./assets/flag/xibanyaguoqi.png": 98324,
	"./assets/icon/book_icon.png": 56647,
	"./assets/icon/facebook.png": 87540,
	"./assets/icon/facebook.svg": 72852,
	"./assets/icon/google.png": 20149,
	"./assets/icon/heart.png": 57214,
	"./assets/icon/heart_fill.png": 23584,
	"./assets/icon/icon_card.png": 16834,
	"./assets/icon/icon_cash.png": 35865,
	"./assets/icon/icon_cash_eur.png": 85660,
	"./assets/icon/icon_fb.png": 13708,
	"./assets/icon/icon_ins.png": 8426,
	"./assets/icon/icon_paypal.png": 88701,
	"./assets/icon/icon_receipt.svg": 60670,
	"./assets/icon/icon_rights.png": 41737,
	"./assets/icon/icon_stripe.png": 82363,
	"./assets/icon/icon_tw.png": 27771,
	"./assets/icon/icon_viva.png": 49684,
	"./assets/icon/input_search.png": 32423,
	"./assets/icon/insta.svg": 50241,
	"./assets/icon/linkedin.png": 19434,
	"./assets/icon/linkedin.svg": 96718,
	"./assets/icon/sumb_down.png": 1482,
	"./assets/icon/sumb_up.png": 60565,
	"./assets/icon/telegram.png": 73173,
	"./assets/icon/tiktok.svg": 15590,
	"./assets/icon/twitter.svg": 55813,
	"./assets/icon/whiteHeart.png": 44657,
	"./assets/icon/x.png": 91522,
	"./assets/icon/youyube.svg": 34060,
	"./assets/iconfont/iconfont": 74752,
	"./assets/iconfont/iconfont.css": 24714,
	"./assets/iconfont/iconfont.js": 74752,
	"./assets/iconfont/iconfont.json": 92930,
	"./assets/iconfont/iconfont.ttf": 12002,
	"./assets/iconfont/iconfont.woff": 69394,
	"./assets/iconfont/iconfont.woff2": 81172,
	"./assets/images/cuiseNot.png": 46815,
	"./assets/images/discount.png": 75058,
	"./assets/images/download_modal_bg.png": 33527,
	"./assets/images/food.png": 23871,
	"./assets/images/google_download.png": 28211,
	"./assets/images/img_home.png": 3286,
	"./assets/images/ios_download.png": 92281,
	"./assets/images/live_chat.png": 93696,
	"./assets/images/location.png": 64318,
	"./assets/images/login_bg.png": 66392,
	"./assets/images/menu-cuise.png": 50284,
	"./assets/images/mobile_banner.png": 41256,
	"./assets/images/modal_tag.svg": 80047,
	"./assets/images/notfoundBg.png": 63335,
	"./assets/images/order_tips_download.jpg": 92559,
	"./assets/images/profile_default.png": 13074,
	"./assets/images/quotation.png": 13005,
	"./assets/images/right.png": 48349,
	"./assets/images/search.png": 34319,
	"./assets/images/skiLogo.png": 78493,
	"./assets/images/special.png": 84706,
	"./assets/index/app_download_bg.png": 59461,
	"./assets/index/download_index_mobile.png": 6809,
	"./assets/index/icon_index_1.png": 89409,
	"./assets/index/icon_index_2.png": 40426,
	"./assets/index/icon_index_3.png": 91187,
	"./assets/index/icon_index_cate2.png": 66385,
	"./assets/index/icon_index_cate3.png": 68520,
	"./assets/index/index_card.png": 47874,
	"./assets/logo-merchant.png": 6400,
	"./assets/logo.png": 33153,
	"./assets/menu/Shop_light.png": 4583,
	"./assets/menu/empty_cart.png": 16718,
	"./assets/menu/empty_cart2.png": 41406,
	"./assets/menu/empty_cart3.png": 12743,
	"./assets/menu/fhrs_0_en-gb.jpg": 11920,
	"./assets/menu/fhrs_1_en-gb.jpg": 32609,
	"./assets/menu/fhrs_2_en-gb.jpg": 1442,
	"./assets/menu/fhrs_3_en-gb.jpg": 79859,
	"./assets/menu/fhrs_4_en-gb.jpg": 7740,
	"./assets/menu/fhrs_5_en-gb.jpg": 43485,
	"./assets/menu/fhrs_AI_en-gb.jpg": 12196,
	"./assets/menu/fhrs_IR_en-gb.jpg": 25463,
	"./assets/menu/fhrs_P_en-gb.jpg": 71184,
	"./assets/menu/fhrs_pass_en-gb.jpg": 90241,
	"./assets/menu/icon_bounds.png": 58661,
	"./assets/menu/icon_eur.png": 92704,
	"./assets/menu/menu_bg_1.png": 33565,
	"./assets/menu/menu_bg_2.png": 66150,
	"./assets/menu/menu_bg_3.png": 34895,
	"./assets/menu/modal_delivery.png": 16896,
	"./assets/menu/modal_dinein.png": 61075,
	"./assets/menu/modal_pickup.png": 58160,
	"./assets/menu/price-fill.svg": 70921,
	"./assets/merchant_pageloading.gif": 58409,
	"./assets/page_loading.gif": 83975,
	"./assets/points/award.png": 11263,
	"./assets/points/point.png": 62742,
	"./assets/policy/faqs_bg.png": 95320,
	"./components/AppleLogin": 98532,
	"./components/AppleLogin.vue": 98532,
	"./components/BindPhone": 50746,
	"./components/BindPhone.vue": 50746,
	"./components/BrowseComps/AddressSearchInput": 64815,
	"./components/BrowseComps/AddressSearchInput.vue": 64815,
	"./components/BrowseComps/BrowseMerchantBox": 19070,
	"./components/BrowseComps/BrowseMerchantBox.vue": 19070,
	"./components/BrowseComps/BrowseSortBox": 98426,
	"./components/BrowseComps/BrowseSortBox.vue": 98426,
	"./components/BrowseComps/ChooseAddressModal": 45501,
	"./components/BrowseComps/ChooseAddressModal.vue": 45501,
	"./components/BrowseComps/TagBar": 93026,
	"./components/BrowseComps/TagBar.vue": 93026,
	"./components/CheckoutComps/AddressBox": 56203,
	"./components/CheckoutComps/AddressBox.vue": 56203,
	"./components/CheckoutComps/CheckLoginBlock": 6124,
	"./components/CheckoutComps/CheckLoginBlock.vue": 6124,
	"./components/CheckoutComps/CheckoutCartBox": 2038,
	"./components/CheckoutComps/CheckoutCartBox.vue": 2038,
	"./components/CheckoutComps/DateTimePicker": 2823,
	"./components/CheckoutComps/DateTimePicker.vue": 2823,
	"./components/CheckoutComps/PaymentBox": 36613,
	"./components/CheckoutComps/PaymentBox.vue": 36613,
	"./components/CloudFlareVerify": 35524,
	"./components/CloudFlareVerify.vue": 35524,
	"./components/CooikeDiv": 85404,
	"./components/CooikeDiv.vue": 85404,
	"./components/CustomerService": 54673,
	"./components/CustomerService.vue": 54673,
	"./components/DownloadAppModal": 99602,
	"./components/DownloadAppModal.vue": 99602,
	"./components/FacebookLogin": 95015,
	"./components/FacebookLogin.vue": 95015,
	"./components/Footer": 9374,
	"./components/Footer.vue": 9374,
	"./components/ForgotPassword": 93623,
	"./components/ForgotPassword.vue": 93623,
	"./components/GoogleLogin": 52150,
	"./components/GoogleLogin.vue": 52150,
	"./components/Header": 77000,
	"./components/Header.vue": 77000,
	"./components/IndexComps/CategoryIndex": 51105,
	"./components/IndexComps/CategoryIndex.vue": 51105,
	"./components/IndexComps/DownloadBox": 47575,
	"./components/IndexComps/DownloadBox.vue": 47575,
	"./components/IndexComps/FaqsBox": 10234,
	"./components/IndexComps/FaqsBox.vue": 10234,
	"./components/IndexComps/MerchantBox": 98063,
	"./components/IndexComps/MerchantBox.vue": 98063,
	"./components/JudgeScreenMask": 80870,
	"./components/JudgeScreenMask.vue": 80870,
	"./components/LoadErrorModal": 11333,
	"./components/LoadErrorModal.vue": 11333,
	"./components/LoginForm": 59885,
	"./components/LoginForm.vue": 59885,
	"./components/MenuComps/CartBox": 27584,
	"./components/MenuComps/CartBox.vue": 27584,
	"./components/MenuComps/CategoryBox": 25852,
	"./components/MenuComps/CategoryBox.vue": 25852,
	"./components/MenuComps/MenuBox": 80537,
	"./components/MenuComps/MenuBox.vue": 80537,
	"./components/MenuComps/MerchantOffMobile": 75477,
	"./components/MenuComps/MerchantOffMobile.vue": 75477,
	"./components/MenuComps/ShopStatus": 69750,
	"./components/MenuComps/ShopStatus.vue": 69750,
	"./components/MerchantItem": 79749,
	"./components/MerchantItem.vue": 79749,
	"./components/MyComps/Account": 84824,
	"./components/MyComps/Account.vue": 84824,
	"./components/MyComps/Address": 9792,
	"./components/MyComps/Address.vue": 9792,
	"./components/MyComps/Booking": 93240,
	"./components/MyComps/Booking.vue": 93240,
	"./components/MyComps/Favorite": 8896,
	"./components/MyComps/Favorite.vue": 8896,
	"./components/MyComps/Orders": 40990,
	"./components/MyComps/Orders.vue": 40990,
	"./components/MyComps/Points": 6693,
	"./components/MyComps/Points.vue": 6693,
	"./components/PageLoading": 58405,
	"./components/PageLoading.vue": 58405,
	"./components/PhoneBtn": 951,
	"./components/PhoneBtn.vue": 951,
	"./components/SignupComps/SignupForm": 99911,
	"./components/SignupComps/SignupForm.vue": 99911,
	"./components/Verifition/Verify": 34155,
	"./components/Verifition/Verify.vue": 34155,
	"./components/Verifition/Verify/VerifyPoints": 62048,
	"./components/Verifition/Verify/VerifyPoints.vue": 62048,
	"./components/Verifition/Verify/VerifySlide": 85315,
	"./components/Verifition/Verify/VerifySlide.vue": 85315,
	"./components/Verifition/api": 52925,
	"./components/Verifition/api/": 52925,
	"./components/Verifition/api/index": 52925,
	"./components/Verifition/api/index.js": 52925,
	"./components/Verifition/utils/ase": 49159,
	"./components/Verifition/utils/ase.js": 49159,
	"./components/Verifition/utils/util": 15162,
	"./components/Verifition/utils/util.js": 15162,
	"./config": 34642,
	"./config/": 34642,
	"./config/index": 34642,
	"./config/index.js": 34642,
	"./firebase": 31394,
	"./firebase.js": 31394,
	"./main": 51406,
	"./main.js": 51406,
	"./mixins/judgeScreenH5": 47258,
	"./mixins/judgeScreenH5.js": 47258,
	"./mixins/loginMixin": 87938,
	"./mixins/loginMixin.js": 87938,
	"./request": 63793,
	"./request/": 63793,
	"./request/index": 63793,
	"./request/index.js": 63793,
	"./router": 39325,
	"./router/": 39325,
	"./router/index": 39325,
	"./router/index.js": 39325,
	"./utils/app": 1558,
	"./utils/app.js": 1558,
	"./utils/bus": 13751,
	"./utils/bus.js": 13751,
	"./utils/debounce": 49098,
	"./utils/debounce.js": 49098,
	"./utils/domain-helper": 88758,
	"./utils/domain-helper.js": 88758,
	"./utils/domainStats": 7962,
	"./utils/domainStats.js": 7962,
	"./utils/facebook": 1741,
	"./utils/facebook.js": 1741,
	"./utils/getPickTimeList": 98057,
	"./utils/getPickTimeList.js": 98057,
	"./utils/jsencrypt": 61317,
	"./utils/jsencrypt.js": 61317,
	"./utils/judgeUseGoogle": 98396,
	"./utils/judgeUseGoogle.js": 98396,
	"./utils/manageCart": 34676,
	"./utils/manageCart.js": 34676,
	"./utils/payment": 7091,
	"./utils/payment.js": 7091,
	"./utils/seo": 89376,
	"./utils/seo.js": 89376,
	"./utils/timeValidation": 97959,
	"./utils/timeValidation.js": 97959,
	"./views": 10782,
	"./views/": 10782,
	"./views/404": 78485,
	"./views/404.vue": 78485,
	"./views/about": 74556,
	"./views/about/": 74556,
	"./views/about/components/BoxFive": 18392,
	"./views/about/components/BoxFive.vue": 18392,
	"./views/about/components/BoxFour": 96353,
	"./views/about/components/BoxFour.vue": 96353,
	"./views/about/components/BoxOne": 39650,
	"./views/about/components/BoxOne.vue": 39650,
	"./views/about/components/BoxSix": 62760,
	"./views/about/components/BoxSix.vue": 62760,
	"./views/about/components/BoxThree": 62467,
	"./views/about/components/BoxThree.vue": 62467,
	"./views/about/components/BoxTwo": 21048,
	"./views/about/components/BoxTwo.vue": 21048,
	"./views/about/index": 74556,
	"./views/about/index.vue": 74556,
	"./views/bind-phone": 98409,
	"./views/bind-phone.vue": 98409,
	"./views/booking": 40934,
	"./views/booking.vue": 40934,
	"./views/browse/browse": 19536,
	"./views/browse/browse.vue": 19536,
	"./views/category": 36732,
	"./views/category/": 36732,
	"./views/category/foodInfo": 34127,
	"./views/category/foodInfo.js": 34127,
	"./views/category/index": 36732,
	"./views/category/index.vue": 36732,
	"./views/checkout": 30930,
	"./views/checkout.vue": 30930,
	"./views/contact": 10384,
	"./views/contact/": 10384,
	"./views/contact/index": 10384,
	"./views/contact/index.vue": 10384,
	"./views/demo": 73271,
	"./views/demo.vue": 73271,
	"./views/develop": 25351,
	"./views/develop/": 25351,
	"./views/develop/index": 25351,
	"./views/develop/index.vue": 25351,
	"./views/firebase-login-webview": 11079,
	"./views/firebase-login-webview.vue": 11079,
	"./views/index": 10782,
	"./views/index.vue": 10782,
	"./views/login": 78665,
	"./views/login.vue": 78665,
	"./views/maintenance": 44803,
	"./views/maintenance.vue": 44803,
	"./views/menu": 96315,
	"./views/menu.vue": 96315,
	"./views/my/editAddress": 12980,
	"./views/my/editAddress.vue": 12980,
	"./views/my/my": 45749,
	"./views/my/my.vue": 45749,
	"./views/my/mySecond": 80780,
	"./views/my/mySecond.vue": 80780,
	"./views/payment/appPayCenter": 41092,
	"./views/payment/appPayCenter.vue": 41092,
	"./views/payment/guavaPay": 91627,
	"./views/payment/guavaPay.vue": 91627,
	"./views/payment/orderSuccess": 49634,
	"./views/payment/orderSuccess.vue": 49634,
	"./views/payment/payDelay": 5041,
	"./views/payment/payDelay.vue": 5041,
	"./views/payment/payFail": 73837,
	"./views/payment/payFail.vue": 73837,
	"./views/payment/paypal": 99184,
	"./views/payment/paypal.vue": 99184,
	"./views/payment/paypalAdvance": 89730,
	"./views/payment/paypalAdvance.vue": 89730,
	"./views/payment/stripe": 30908,
	"./views/payment/stripe.vue": 30908,
	"./views/payment/trustPayment": 86180,
	"./views/payment/trustPayment.vue": 86180,
	"./views/payment/trustPaymentJs": 81405,
	"./views/payment/trustPaymentJs.vue": 81405,
	"./views/payment/vivaWallet": 58665,
	"./views/payment/vivaWallet.vue": 58665,
	"./views/policy/cookiePolicy": 82465,
	"./views/policy/cookiePolicy.vue": 82465,
	"./views/policy/faqs": 8755,
	"./views/policy/faqs.vue": 8755,
	"./views/policy/private": 8856,
	"./views/policy/private.vue": 8856,
	"./views/policy/refundAndCancellations": 7663,
	"./views/policy/refundAndCancellations.vue": 7663,
	"./views/policy/termsAndConditions": 9036,
	"./views/policy/termsAndConditions.vue": 9036,
	"./views/quick/quickLogin": 69345,
	"./views/quick/quickLogin.vue": 69345,
	"./views/review": 61739,
	"./views/review.vue": 61739,
	"./views/signup": 31849,
	"./views/signup.vue": 31849
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 25538;